import JurisprudenceFile from './Bl/JurisprudenceFile'
import JurisprudenceCategory from './Bl/JurisprudenceCategory'
import JurisprudenceCategoryCard from './Bl/JurisprudenceCategoryCard'
import Resume from './Bl/Resume'
import ResumeCard from './Bl/ResumeCard'
import ProcessCategory from './Bl/ProcessCategory'
import ProcessCategoryCard from './Bl/ProcessCategoryCard'
import StoryCategory from './Bl/StoryCategory'
import StoryCategoryCard from './Bl/StoryCategoryCard'
import BankAccount from './Bl/BankAccount'
import Question from './Bl/Question'
import ProcessCard from './Bl/ProcessCard'
import Process from './Bl/Process'
import ProcessItem from './Bl/ProcessItem'
import ProcessFileType from './Bl/ProcessFileType'
import ProcessType from './Bl/ProcessType'
import BannerCard from './Bl/BannerCard'
import QuestionCard from './Bl/QuestionCard'
import ProcessTypeCard from './Bl/ProcessTypeCard'
import Banner from './Bl/Banner'
import User from './System/User'
import Story from './Bl/Story'

export default {
  Bl: {
    BankAccount,
    QuestionCard,
    Question,
    JurisprudenceFile,
    JurisprudenceCategory,
    JurisprudenceCategoryCard,
    Resume,
    ResumeCard,
    ProcessCategory,
    ProcessCategoryCard,
    StoryCategory,
    StoryCategoryCard,
    ProcessFileType,
    ProcessTypeCard,
    ProcessType,
    ProcessItem,
    ProcessCard,
    Process,
    Story,
    BannerCard,
    Banner
  },
  System: {
    User
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/index.js